import styled from '@emotion/styled'
import { Link as GatsbyLink } from 'gatsby'
import { ReactNode } from 'react'

import { StyleProps, createStyles } from '../utils'

type LinkElementProps = Omit<LinkProps, 'to'> & {
  href?: string
  to?: string
}

export type LinkProps = {
  'aria-label'?: string
  children?: ReactNode
  className?: string
  external?: boolean
  onClick?: () => void
  openNewTab?: boolean
  styles?: StyleProps
  to: string
  underlined?: boolean
  color?: string
}

const elementStyles = (props: LinkElementProps) => ({
  cursor: 'pointer',
  textDecoration: props.underlined ? 'underlined' : 'none',
  color: props.color,
  ...createStyles(props.styles),
})

const Anchor = styled.a<LinkElementProps>(elementStyles)

const GatsbyAnchor = styled(GatsbyLink)<LinkElementProps>(elementStyles)

export const Link = (props: LinkProps) => {
  const isExternalLink = props.external || /^(mailto:|tel:)/.test(props.to)

  if (props.openNewTab || isExternalLink) {
    return (
      <Anchor
        aria-label={props['aria-label']}
        className={props.className}
        href={props.to}
        onClick={props.onClick}
        rel="noreferrer"
        styles={props.styles}
        target={props.openNewTab ? '_blank' : undefined}
        underlined={props.underlined}
        color={props.color}
      >
        {props.children}
      </Anchor>
    )
  }

  return (
    <GatsbyAnchor
      aria-label={props['aria-label']}
      className={props.className}
      onClick={props.onClick}
      styles={props.styles}
      to={props.to}
      underlined={props.underlined}
      color={props.color}
    >
      {props.children}
    </GatsbyAnchor>
  )
}
